import { Helmet } from 'react-helmet';
import classNames from 'classnames';
import { ReactElement, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { allFramesInitialized } from './host';
import { LoadingOverlay } from '@comptia-sso/core';
import { useSierra } from '../../app/SierraContext';

export const SierraView = (): ReactElement => {
  const { t } = useTranslation();
  const [initialized, setInitialized] = useState(false);
  const sierra = useSierra();

  function checkLoaded() {
    const newInitialized = allFramesInitialized();
    console.log('check initialized: ' + newInitialized);
    setInitialized(newInitialized);
    if (!newInitialized) setTimeout(checkLoaded, 500);
  }

  useEffect(() => {
    checkLoaded();
  }, []);

  return (
    <>
      <Helmet titleTemplate="%s | CompTIA">
        <title>{sierra.getCurrentRouteTitle()}</title>
      </Helmet>
      <div>
        <LoadingOverlay
          animateOnEnter={false}
          isOpen={!initialized}
          text={t('Loading.Default')}
        />
      </div>
    </>
  );
};
